module.exports = __webpack_public_path__ + "media/assets/gsv-609dcb8a2d5f08c642d383793c640a17.svg";